import React, {Component} from 'react';
import {Link} from 'react-router';
import {Card, Divider, Table} from 'antd';
import moment from 'moment';
import {queryIncCustomBusinessOregistapp} from '@api/incubator/custom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settledList: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getIncCustomBusinessOregistapp();
  }

  getIncCustomBusinessOregistapp = () => {
    queryIncCustomBusinessOregistapp({
        customUuid: this.props.customUuid,
        incubatorUuid: this.props.incubatorUuid,
      })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
          });
        }
      });
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'custom',
        key: 'custom',
      },
      {
        title: '占用地址',
        dataIndex: 'addresses',
        key: 'addresses',
        render: (text, record) => {
          return (
            <div>
              {text.map(item => {
                return (
                  <p style={{ marginBottom: '0' }} key={item.name}>
                    {item.name}
                  </p>
                );
              })}
            </div>
          );
        },
      },
      {
        title: '交易类型',
        dataIndex: 'settledType',
        key: 'settledType',
        render: (text, record) => {
          return <div>{record.settled.price ? '收费注册' : '免费注册'}</div>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '关联基础孵化合同',
        dataIndex: 'settledUuid',
        key: 'settledUuid',
        render: (text, record) => {
          return (
            <Link to={`/incubator/contract/${record.settled.businessUuid}/info`}>
              {record.settled.no}
            </Link>
          );
        },
      },
      {
        title: '到期时间',
        dataIndex: 'deadline',
        key: 'deadline',
        render: (text, record) => {
          let day = 0;
          if (record.settled.deadline) {
            day = Math.floor((Date.now() - record.settled.deadline) / 86400000);
          }

          const element =
            day > 0 ? (
              <span style={{ color: 'red', marginLeft: '10px' }}>（逾期{day}天）</span>
            ) : (
              <span style={{ marginLeft: '10px' }}>（剩余{Math.abs(day)}天）</span>
            );
          return (
            <span>
              {record.settled.deadline
                ? moment.unix(record.settled.deadline / 1000).format('YYYY-MM-DD')
                : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '迁出时间',
        dataIndex: 'moveOutDate',
        key: 'moveOutDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              {record.moveOutInstance ? null : (
                <span>
                  <Link to={`/incubator/oregistappMoveOut_manage/add/${record.uuid}`}>
                    迁出地址
                  </Link>
                  <Divider type="vertical" />
                </span>
              )}

              <Link to={`/incubator/oregistapp_manage/open/${record.uuid}`}>查看注册申请</Link>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { settledList } = this.state;
    return (
      <Card title="在签地址">
        <Table
          columns={this.columns()}
          dataSource={settledList}
          pagination={false}
          rowKey="index"
        />
      </Card>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/detail/CardAddress.js